/**
 * Backlinks Section Transformers
 * Aggregates all backlinks-related transformers and provides section-level utilities
 */

import { transformBacklinksScore } from './backlinksScoreTransformer';

// Re-export individual transformers
export { transformBacklinksScore } from './backlinksScoreTransformer';

/**
 * Transforms backlinks-related criteria from WooRank API response.
 * (score-only for legacy parity).
 *
 * @param {Object} apiData - The SEO audit data object (already response.data from API)
 * @returns {Object} transformed backlinks section data
 */
export const transformBacklinksSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const backlinksScore = transformBacklinksScore(criteria?.backlinks_score);

  const allResults = [backlinksScore];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    backlinksScore,
  };
};

export default transformBacklinksSection;


